export const KIM_MARKED_OPTIONS = { async: false, breaks: true } as const;
